<script lang="ts">
	import { format } from 'svelte-i18n';
	import WeatherLocationModal from 'src/components/Weather/WeatherLocationModal.svelte';
	import { Alert } from '@Shelly/shelly-design-system';

	let showModal = false;
</script>

<Alert
	type="info"
	heading={$format('alert_heading_dashboard_wizard_weather_info', {
		default: 'Do you want to change your weather info?',
	})}
	cta={{
		title: `${$format('alert_cta_dashboard_wizard_weather_info_link', {
			default: 'Go to weather info',
		})}`,
	}}
	on:cta_click={() => {
		showModal = true;
	}}
/>

{#if showModal}
	<WeatherLocationModal bind:showModal />
{/if}
